export const API_ORIGIN =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_BACKEND_URL ||
  'http://localhost:5000';

export const API_BASE_URL = API_ORIGIN;

export const INTERVIEW_API_BASE_URL = `${API_ORIGIN}/api/interview`;

export const NODE_INTERVIEW_API_BASE_URL =
  import.meta.env.VITE_NODE_URL || 'http://localhost:5000/api/interview';

export const getAccessToken = () =>
  localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

export const getAuthHeaders = () => {
  const token = getAccessToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
};
